import React from "react";
import MyCollectionCard from "./MyCollectionCard";

const MyCollection = () => {

    const cardItems = [1, 2, 3, 4, 5, 6];

    return (
        <>
            <div className="_creator_top_wrap">
                <div className="container">
                    <div className="row align-items-center">
                        <div className="col-xl-12 col-lg-12 col-md-12 col-sm-12">
                            <div className="_stats_title_wrap">
                                <h2 className="_creator_title">My Collections</h2>
                                <p className="_creator_txt">The top NFTs on AllBlocks, ranked by volume, floor price and other
                                    statistics</p>
                            </div>
                        </div>
                    </div>
                    <div className="_mycol_cards_wrapper">
                        <div className="row">
                            {
                                cardItems.map((card, id) => {
                                    return <MyCollectionCard key={id} />
                                })
                            }
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}
export default MyCollection;